"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Card_1 = __importDefault(require("@mui/material/Card"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Stack_1 = __importDefault(require("@mui/material/Stack"));
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const DialogContentText_1 = __importDefault(require("@mui/material/DialogContentText"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
const Snackbar_1 = __importDefault(require("@mui/material/Snackbar"));
const Alert_1 = __importDefault(require("@mui/material/Alert"));
const styles_1 = require("@mui/material/styles");
const Button_1 = __importDefault(require("@mui/material/Button"));
const AddCard_1 = __importDefault(require("@mui/icons-material/AddCard"));
const PaymentSubscription_1 = __importDefault(require("../PaymentSubscription"));
const AddSubscription_1 = __importDefault(require("../AddSubscription"));
const shared_1 = require("../shared");
const SubButton = (0, styles_1.styled)(Button_1.default)(({ theme }) => ({
    color: '#FFFF',
    background: 'blue',
    textTransform: 'none',
    fontFamily: 'Poppins',
    fontSize: '0.8vmax',
    justifyContent: 'center',
    fontWeight: 'bold',
    alignContent: 'center',
    width: '20vh',
    height: '5vh',
    borderRadius: '0.5vmax',
    '&:hover': {
        background: 'linear-gradient(180deg, #0146C7 0%, #053898 100%)',
    },
    '&.Mui-disabled': {
        color: '#F2F2F2',
        background: 'grey',
    },
}));
const MySubscription = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { userId } = (0, react_router_dom_1.useParams)();
    const [greeting, setGreeting] = (0, react_1.useState)('Good Morning');
    const [subscriptions, setSubscriptions] = (0, react_1.useState)([]);
    const [subscribed, setSubscribed] = (0, react_1.useState)([]);
    const [paymentDetails, setPaymentDetails] = (0, react_1.useState)(null);
    const [allSubscribed, setAllSubscribed] = (0, react_1.useState)([]);
    const [planIdToCancel, setPlanIdToCancel] = (0, react_1.useState)(null);
    const [open, setOpen] = (0, react_1.useState)(false);
    const [Extendopen, setExtendOpen] = (0, react_1.useState)(false);
    const [alertOpen, setAlertOpen] = (0, react_1.useState)(false);
    const [dialogOpen, setDialogOpen] = react_1.default.useState(false);
    const md = require('markdown-it')({
        html: true,
        linkify: true,
        typographer: true,
    });
    (0, react_1.useEffect)(() => {
        initData();
        const today = new Date();
        const curHr = today.getHours();
        if (curHr < 12) {
            setGreeting('Good Morning');
        }
        else if (curHr < 18) {
            setGreeting('Good Afternoon');
        }
        else {
            setGreeting('Good Evening');
        }
    }, []);
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month and pad with leading zero if necessary
        const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero if necessary
        const year = date.getFullYear(); // Get full year
        return `${month}-${day}-${year}`;
    };
    const initData = async () => {
        const subData = await (0, shared_1.getDesmosSubscribed)(userId);
        const allSubscribedData = (subData === null || subData === void 0 ? void 0 : subData.allData) || [];
        setAllSubscribed(allSubscribedData);
        if (allSubscribedData.length > 0) {
            // Process each subscription
            const subscribedDetails = await Promise.all(allSubscribedData.map(async (sub) => {
                if (sub && Object.keys(sub).length > 0 && sub.ongoing) {
                    // Fetch any additional details if needed, e.g., card details
                    getCardDetails(sub.transactionId);
                    return sub;
                }
                return null;
            }));
            // Filter out any null values and update the subscribed state
            setSubscribed(subscribedDetails.filter((sub) => sub !== null));
            // Fetch subscription data for each planId in allSubscribed
            const subscriptionsData = await Promise.all(allSubscribedData.map(async (sub) => {
                var _a;
                const filter = `filters[id][$eq]=${sub.planId}`;
                const data = await (0, shared_1.getStrapiData)(`subscriptions?${filter}&populate=*`);
                return data && data.length > 0 ? (_a = data[0]) === null || _a === void 0 ? void 0 : _a.attributes : null;
            }));
            // Filter out any null values and set the subscriptions state
            setSubscriptions(subscriptionsData.filter((sub) => sub !== null));
        }
        if (!(subData === null || subData === void 0 ? void 0 : subData.isSubscribed)) {
            navigate(`/subscriptions/${userId}`);
        }
    };
    const getCardDetails = async (transactionId) => {
        if (!transactionId) {
            console.log('No transaction ID available');
            return;
        }
        try {
            const response = await (0, shared_1.callApi)(`payment/${transactionId}`, 'GET');
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            setPaymentDetails(data);
        }
        catch (error) {
            console.log('Error:', error);
        }
    };
    const updateCardDetail = async (transactionId) => {
        try {
            let body = Object.assign(Object.assign({}, paymentDetails), { creditCardNum: '' });
            console.log('transactionId', transactionId);
            console.log('body', body);
            await (0, shared_1.callApi)(`payment/${transactionId}`, 'PUT', body);
            console.log('updated succesfully');
            return true;
        }
        catch (error) {
            console.error('Error while updatting the user data', error);
            return false;
        }
    };
    // const handleSubscribe = (planId) => async (event: React.MouseEvent<HTMLElement>) => {
    // 	console.log('planID',planId)
    // 	const regData = await getUserData();
    // 	const user = await getCurrentUser();
    // 	const cookies = new Cookies();
    // 	const domain = getDomain();
    // 	let redirect_url = await getMainUrl();
    // 	let redirect_url_payment = redirect_url + `/makePayment`;
    // 	let redirect_url_register = redirect_url + `/registration`;
    // 	let redirect_url_confirm = redirect_url + `/confirm`;
    // 	cookies.remove('desmos_subscription_id');
    // 	cookies.remove('payment_source_from');
    // 	cookies.set('desmos_subscription_id', planId, domain);
    // 	cookies.set('payment_source_from', 'desmos_subscription_extension', domain);
    // 	if (user === null) {
    // 		window.location.replace(redirect_url_confirm);
    // 	} else if (regData === null) {
    // 		window.location.replace(redirect_url_register);
    // 	} else {
    // 		window.location.replace(redirect_url_payment);
    // 	}
    // };
    // console.log('planIDtoCancel',setPlanIdToCancel)
    const handleDialogYes = () => {
        setDialogOpen(false);
        handleCancelSubscribeAfterConfirm(planIdToCancel);
    };
    const handleDialogNo = () => {
        setDialogOpen(false);
    };
    const handleCancelSubscribe = async (planId) => {
        setPlanIdToCancel(planId);
        setDialogOpen(true);
    };
    const handleSnackBarOpen = () => {
        setAlertOpen(true);
    };
    const handleSnackBarClose = () => {
        setAlertOpen(false);
    };
    const handleClose = () => {
        setExtendOpen(false);
        initData();
    };
    const handleCancelSubscribeAfterConfirm = async (planId) => {
        var _a;
        const data = allSubscribed.map((item) => {
            if (item.planId === planId && item.ongoing === true) {
                item.isCancelled = true;
                item.cvv = null;
                item.expirationDate = '';
            }
            return item;
        });
        const body = {
            userId: userId,
            subscribedDesmos: data,
        };
        const saveData = await (0, shared_1.updateUserDetail)(userId, body);
        if (saveData) {
            const subscriptionEndDate = (_a = data.find((item) => item.planId === planId)) === null || _a === void 0 ? void 0 : _a.endDate;
            await updateCardDetail(paymentDetails.transactionId);
            sendCancellationMail(userId, subscriptionEndDate);
        }
    };
    const sendCancellationMail = (userId, subscriptionEndDate) => {
        try {
            const mailData = {
                id: userId,
                endDate: subscriptionEndDate,
            };
            const response = (0, shared_1.callApi)('auth/SubscriptionCancelled', 'POST', mailData);
            console.log('Mail sent successfully:', response);
        }
        catch (error) {
            console.log('Error sending mail:', error);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'home-page-root' }, { children: [(0, jsx_runtime_1.jsx)("img", { src: '/assets/background_5.png', alt: 'home-screen', className: 'bg_1_image', loading: 'lazy' }), (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: 'column', spacing: 4, sx: { width: '100%', zIndex: 1 } }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ className: 'college_link_header' }, { children: "My Desmos PLAN" })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'my-sub-par-div-style' }, { children: (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ container: true, display: 'flex', flexDirection: subscribed.length === 1 ? 'row' : 'column', alignItems: 'center', padding: 2, width: '60vh', height: '60vh', gap: 2 }, { children: subscribed.map((sub, index) => {
                                var _a, _b, _c, _d, _e, _f, _g, _h;
                                // Get current date
                                const currentDate = new Date();
                                const startDate = new Date(sub.startDate);
                                let endDate = sub === null || sub === void 0 ? void 0 : sub.endDate;
                                let todayDate = new Date();
                                const offset = todayDate.getTimezoneOffset();
                                todayDate = new Date(todayDate.getTime() - offset * 60 * 1000);
                                let todayDateStr = new Date(todayDate.toISOString().split('T')[0]);
                                let endDateStr = new Date(endDate.slice(0, 10));
                                // Check if the subscription is upcoming (i.e., not currently active)
                                const isUpcoming = currentDate < startDate;
                                return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [sub.planId !== -1 && sub.ongoing && todayDateStr <= endDateStr && ((0, jsx_runtime_1.jsx)(Card_1.default, Object.assign({ className: 'sub-card-rad-style', sx: {
                                                boxShadow: 20,
                                                ':hover': { backgroundColor: isUpcoming ? 'initial' : 'blue' },
                                                position: 'relative',
                                                opacity: isUpcoming ? 0.5 : 1, // Reduce opacity if upcoming
                                            } }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'sub-main-div-rad-style' }, { children: [isUpcoming && ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: {
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: 0,
                                                            width: '100%',
                                                            height: '100%',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                            color: 'white',
                                                            fontSize: '28px',
                                                            fontWeight: 'bold',
                                                            zIndex: 1, // Ensure it appears on top of the card content
                                                        } }, { children: "Upcoming" }))), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'My_sub-period-style' }, { children: [(_a = subscriptions[index]) === null || _a === void 0 ? void 0 : _a.Period, ((_b = subscriptions[index]) === null || _b === void 0 ? void 0 : _b.IsAutoRenewal) && !(sub === null || sub === void 0 ? void 0 : sub.isCancelled) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ title: 'Edit payment details' }, { children: (0, jsx_runtime_1.jsx)(AddCard_1.default, { sx: { marginLeft: 5, cursor: isUpcoming ? 'default' : 'pointer' }, onClick: () => !isUpcoming && setOpen(true) }) })), (0, jsx_runtime_1.jsx)(PaymentSubscription_1.default, { open: open, onClose: () => setOpen(false), subscription: subscriptions[index], subscribed: sub, handleSnackBarOpen: handleSnackBarOpen, handleSnackBarClose: handleSnackBarClose })] }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'My-sub-monthly-style' }, { children: ["$", ((_c = subscriptions[index]) === null || _c === void 0 ? void 0 : _c.IsAutoRenewal) ? ((_d = subscriptions[index]) === null || _d === void 0 ? void 0 : _d.Amount) + '/Month' : (_e = subscriptions[index]) === null || _e === void 0 ? void 0 : _e.Amount] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'sub-my-desc-style' }, { children: [(0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: { __html: md.render(((_f = subscriptions[index]) === null || _f === void 0 ? void 0 : _f.Description) || '') } }), (0, jsx_runtime_1.jsx)("span", { style: {
                                                                    fontSize: '16px',
                                                                    textAlign: 'center',
                                                                    display: 'block', // Make the span a block-level element for proper centering
                                                                }, dangerouslySetInnerHTML: {
                                                                    __html: md.render(`Start Date: ${formatDate(sub.startDate)}<br/>${((_g = subscriptions[index]) === null || _g === void 0 ? void 0 : _g.IsAutoRenewal) ? 'Renewal Date' : 'End Date'}: ${formatDate(sub.endDate)}`),
                                                                } })] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: { display: 'flex', justifyContent: 'space-evenly', padding: '15px' } }, { children: ((_h = subscriptions[index]) === null || _h === void 0 ? void 0 : _h.IsAutoRenewal) ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SubButton, Object.assign({ onClick: () => handleCancelSubscribe(sub.planId), disabled: sub.isCancelled }, { children: sub.isCancelled ? 'Cancelled' : 'Cancel Subscription' })), sub.isCancelled && subscribed.length === 1 ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SubButton, Object.assign({ disabled: false, onClick: () => setExtendOpen(true) }, { children: "Extend Subscription" })), (0, jsx_runtime_1.jsx)(AddSubscription_1.default, { open: Extendopen, onClose: handleClose, isFromUser: true })] })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}))] })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: subscribed.length === 1 ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SubButton, Object.assign({ disabled: sub.isCancelled || isUpcoming, onClick: () => !isUpcoming && setExtendOpen(true) }, { children: "Extend Subscription" })), (0, jsx_runtime_1.jsx)(AddSubscription_1.default, { open: Extendopen, onClose: handleClose, isFromUser: true })] })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})) })) }))] })) }))), sub.planId === -1 && ((0, jsx_runtime_1.jsx)(Card_1.default, Object.assign({ className: 'sub-card-rad-style', sx: { boxShadow: 20, ':hover': { backgroundColor: 'blue' } } }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'sub-main-div-rad-style' }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'sub-period-style' }, { children: "Desmos Giveaway" })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'sub-desc-style' }, { children: (0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: { __html: md.render('This is a free giveaway included during course enrollment, valid for ' + sub.period + ' Days.') } }) }))] })) })))] }, index));
                            }) })) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'sub-div-footer-style' }, { children: [(0, jsx_runtime_1.jsx)("b", { children: "Questions?" }), (0, jsx_runtime_1.jsxs)("div", { children: ["Contact us at\u00A0", (0, jsx_runtime_1.jsx)("a", Object.assign({ href: 'mailto:info@alphaprep.com' }, { children: "info@alphaprep.com" })), "\u00A0or ", (0, jsx_runtime_1.jsx)("a", Object.assign({ href: '' }, { children: "+18888425742" }))] })] }))] })), (0, jsx_runtime_1.jsxs)(Dialog_1.default, Object.assign({ open: dialogOpen, onClose: handleDialogNo, "aria-labelledby": 'alert-dialog-title', "aria-describedby": 'alert-dialog-description' }, { children: [(0, jsx_runtime_1.jsx)(DialogTitle_1.default, Object.assign({ id: 'alert-dialog-title' }, { children: 'Are you sure to unsubscribe the current plan?' })), (0, jsx_runtime_1.jsx)(DialogContent_1.default, { children: (0, jsx_runtime_1.jsx)(DialogContentText_1.default, Object.assign({ id: 'alert-dialog-description' }, { children: "You cannot undo this action" })) }), (0, jsx_runtime_1.jsxs)(DialogActions_1.default, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: handleDialogNo }, { children: "No" })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: handleDialogYes, autoFocus: true }, { children: "Yes" }))] })] })), (0, jsx_runtime_1.jsx)(Snackbar_1.default, Object.assign({ autoHideDuration: 6000, onClose: handleSnackBarClose, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, open: alertOpen }, { children: (0, jsx_runtime_1.jsx)(Alert_1.default, Object.assign({ onClose: handleSnackBarClose, severity: 'success', variant: 'filled', sx: { width: '100%' } }, { children: "Saved Successfully!" })) }))] })));
};
exports.default = MySubscription;
